import { EmptyView } from './EmptyView';
const meta = {
    title: 'Features/AIChatWidget/EmptyView',
    component: EmptyView
};
export default meta;
export const Default = {
    args: {
        onSelectPrompt: (prompt) => console.log('Prompt selected:', prompt)
    }
};
export const WithUserName = {
    args: {
        userName: 'John',
        onSelectPrompt: (prompt) => console.log('Prompt selected:', prompt)
    }
};
